module.exports = {"congratsMessage":"<0/> <1>{firstName}</1><2 /><3 /><4 />"}